/**
 * 科研仪器相关 API
 */
import request from '@/utils/request'
import baseUrl from '@/utils/baseUrl'

const instrumentApi = {}

/**
 * 获取仪器列表
 * @param {Object} params 查询参数
 * @param {Number} params.pageNum 页码
 * @param {Number} params.pageSize 每页条数
 * @param {String} params.instrumentType 仪器类型（字典 yInstrumentType 的 itemCode）
 * @param {String} params.keyword 关键词
 * @returns {Promise}
 *
 * TODO: 根据后端实际接口 URL 调整 url 和 baseURL
 */
instrumentApi.getInstrumentList = function(params = {}) {
  return request({
    url: '/portal/instrument/getList',
    baseURL: baseUrl.instrument,
    method: 'get',
    params: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 12,
      instrumentType: params.instrumentType || '',
      keyword: params.keyword || ''
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取仪器详情
 * @param {String} id 仪器ID
 * @returns {Promise}
 */
instrumentApi.getInstrumentDetail = function(id) {
  return request({
    url: '/portal/instrument/get',
    baseURL: baseUrl.instrument,
    method: 'get',
    params: {
      id
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取类似仪器推荐列表
 * GET /portal/instrument/getRecomList
 * @param {String} id 仪器ID（必填）
 * @param {Number} pageSize 每页条数（必填）
 */
instrumentApi.getInstrumentRecomList = function(id, pageSize = 8) {
  return request({
    url: '/portal/instrument/getRecomList',
    baseURL: baseUrl.instrument,
    method: 'get',
    params: {
      id,
      pageSize
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default instrumentApi

